import React, { Reducer, useMemo, useReducer } from 'react';
import { EventAction, EventState, EventReducer } from './EventsReducer';
import { EventContext } from '../hooks/useEventContext';

type EventProviderProps = {
  children: React.ReactNode;
};

export const EventProvider = (props: EventProviderProps) => {
  const [state, dispatch] = useReducer<Reducer<EventState, EventAction>>(
    EventReducer,
    {
      initial: true,
    },
  );
  const contextValue = useMemo(() => ({ state, dispatch }), [state, dispatch]);
  return (
    <EventContext.Provider
      value={{ state: contextValue.state, dispatch: contextValue.dispatch }}
    >
      {props.children}
    </EventContext.Provider>
  );
};
